import React, { useEffect, useState, useRef, useMemo } from "react";
import { set, useForm } from "react-hook-form";
import axios from "axios";
import { useOutletContext, Link, useLocation, useNavigate } from "react-router-dom";
import $ from "jquery";

import * as pdfjsLib from "pdfjs-dist";
import * as mammoth from "mammoth";
import toastr from "../../utils/toast";
import { MaterialReactTable } from "material-react-table";
import CreatableSelect from "react-select/creatable";
import Select from "react-select";
import SpeechToText from "./SpeechToText";
import { openInAppTab } from "../../utils/tabNavigation";
pdfjsLib.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.min.js`;

function UploadJd({
  submit,
  selectedDesignation,
  selectedCountry,
  selectedFunction,
  selectedIndustry,
  related_industries,
  related_countries,
  mode = "jd", // "jd" = type / voice / upload, "role" = existing role's JD file
  roleId = null, // role mode only: a known role (role view page) — no picker, auto-runs
}) {
  const { setGlobalLoading, token } = useOutletContext();
  const {
    register,
    setValue,
    formState: { errors },
    handleSubmit,
  } = useForm();

  const [text, setText] = useState("");
  const [speechKey, setSpeechKey] = useState(0);
  const [file, setFile] = useState(null);
  const [functions, setFunctions] = useState([]);
  const [country, setCountry] = useState([]);
  const [Industries, setIndustries] = useState([]);
  const [keywords, setkeywords] = useState([]);
  const [gpt_Function, setgptfunction] = useState(null);
  const [gpt_Industry, setgptindustry] = useState(null);
  const [gpt__Country, setgptcountry] = useState(null);
  const [gpt_Designation, setgptDesignation] = useState(null);
  const [options, setOptions] = useState([]);
  const [myroles, setmyroles] = useState([]);
  const [selectedmyroles, setselectedmyroles] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);
  const [arr, setArr] = useState(false);
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const PINE_BASE_URL = process.env.REACT_APP_PINE_BASE_URL;
  const [rowSelection, setRowSelection] = useState({});
  const keywordDebounceRef = useRef(null);
  const [lastQueryText, setLastQueryText] = useState("");
  const [CandidateIds, setCandidateIds] = useState([]);

  const hasAutoSearched = useRef(false);

  const [clarification, setClarification] = useState(null);
  const [customClarificationText, setCustomClarificationText] = useState("");

  const [isSearching, setIsSearching] = useState(false);
  const resultsRef = useRef(null);

  // Existing Role mode
  const [roleOptions, setRoleOptions] = useState([]);
  const [selectedRole, setSelectedRole] = useState(null);

  // AI Candidates page (roleId): "Edit Columns" filter form, pre-filled from
  // what the AI extracted. Values are option ids (as strings).
  const [showFilterForm, setShowFilterForm] = useState(false);
  const [filters, setFilters] = useState({
    designation: "",
    functionId: "",
    countryIds: [],
    industryIds: [],
  });

  const onSubmit = async (data) => {
    if (!lastQueryText) {
      toastr.error(
        "Please enter a role brief, record audio, or upload a JD first.",
      );
      return;
    }

    const mustHaveSkills = data.keywords?.length
      ? data.keywords
      : keywords.filter((k) => k.type === "must_have").map((k) => k.value);

    await AskAi(lastQueryText, mustHaveSkills);
  };

  const OPTIONAL_COLUMN_CONFIG = [
    {
      key: "total_experience_years",
      header: "Total Experience (yrs)",
      format: (v) => (v != null ? Number(v).toFixed(1) : "-"),
    },
    {
      key: "relevant_experience_years",
      header: "Relevant Experience (yrs)",
      format: (v) => (v != null ? Number(v).toFixed(1) : "-"),
    },
    { key: "previous_company", header: "Previous Company" },
    { key: "previous_industry", header: "Previous Industry" },
    { key: "last_company", header: "Last Company" },
    { key: "last_industry", header: "Last Industry" },
  ];

  const columns = useMemo(() => {
    const baseColumns = [
      {
        header: "Full Name",
        id: "full_name",
        accessorFn: (row) =>
          `${row.firstname || ""} ${row.lastname || ""}`.trim(),
        Cell: ({ row }) => (
          <div className="d-flex align-items-center">
            <Link
              to={`/candidates/view/${row.original.id}`}
              target="_blank"
              className="avatar avatar-md border avatar-rounded"
              onClick={(event) => {
                event.preventDefault();
                openInAppTab(
                  `/candidates/view/${row.original.id}`,
                );
              }}
            >
              <img
                src={
                  row.original.userpic
                    ? `${PINE_BASE_URL}/files/candidates/picture/${row.original.userpic}`
                    : `${PINE_BASE_URL}/files/candidates/picture/no-pic.png`
                }
                className="img-fluid"
                alt="img"
              />
            </Link>
            <div className="ms-2">
              <h6 className="fw-medium fs-12 mbm-12">
                <Link
                  to={`/candidates/view/${row.original.id}`}
                  target="_blank"
                  onClick={(event) => {
                    event.preventDefault();
                    openInAppTab(
                      `/candidates/view/${row.original.id}`,
                    );
                  }}
                >
                  {row.original.firstname} {row.original.lastname}
                </Link>
                {row.original.linkdin_url && (
                  <a
                    className="ms-2"
                    target="_blank"
                    href={row.original.linkdin_url}
                  >
                    <i className="fa-brands fa-linkedin"></i>
                  </a>
                )}
                {(row.original.phone || row.original.mobile) && (
                  <a
                    className="ms-2"
                    target="_blank"
                    title={`${row.original.phone ? row.original.phone : ""} ${row.original.mobile ? row.original.mobile : ""}`}
                  >
                    <i className="fa-brands fa-whatsapp"></i>
                  </a>
                )}
                {row.original.email && (
                  <a
                    className="ms-2"
                    target="_blank"
                    title={row.original.email}
                  >
                    <i className="fa-solid fa-envelope"></i>
                  </a>
                )}
              </h6>
            </div>
          </div>
        ),
      },
      { header: "Company", accessorKey: "current_company" },
      { header: "Designation", accessorKey: "designation" },
      { header: "Major Industry", accessorKey: "major_industry" },
      { header: "Minor Industry", accessorKey: "minor_industry" },
      { header: "Child Industry", accessorKey: "child_industry" },
      { header: "Function", accessorKey: "function_name" },
      { header: "Country", accessorKey: "country_name" },
    ];

    if (!options.length) return baseColumns;

    const dynamicColumns = OPTIONAL_COLUMN_CONFIG.filter(({ key }) =>
      options.some((row) => row[key] !== undefined && row[key] !== null),
    ).map(({ key, header, format }) => ({
      header,
      accessorKey: key,
      Cell: format ? ({ cell }) => format(cell.getValue()) : undefined,
    }));

    const hasMatchReasons = options.some(
      (row) => row.match_reasons !== undefined && row.match_reasons !== null,
    );

    const matchReasonsColumn = hasMatchReasons
      ? [
          {
            header: "Why Matched",
            accessorKey: "match_reasons",
            Cell: ({ cell }) => (
              <ul className="mb-0 ps-3 text-start">
                {(cell.getValue() || []).map((reason, i) => (
                  <li key={i} className="fs-11">
                    {reason}
                  </li>
                ))}
              </ul>
            ),
          },
        ]
      : [];

    const hasAiScore = options.some(
      (row) => row.ai_score !== undefined && row.ai_score !== null,
    );

    const scoreColumn = hasAiScore
      ? [
          {
            header: "Match %",
            accessorKey: "match_percentage",
            Cell: ({ cell }) => {
              const score = cell.getValue();
              let color = "";
              if (score >= 60) {
                color = "success";
              } else if (score >= 40 && score < 60) {
                color = "warning";
              } else if (score < 40) {
                color = "danger";
              }

              return (
                <span className={`badge bg-${color}`}>
                  {cell.getValue() ?? "-"}
                </span>
              );
            },
          },
        ]
      : [];

    return [
      ...baseColumns,
      ...dynamicColumns,
      ...matchReasonsColumn,
      ...scoreColumn,
    ];
  }, [options, PINE_BASE_URL]);

  const cleanExtractedText = (text, names) => {
    const namesToRemove = names; // 🔁 Add more names here
    let cleanedText = text;

    // Remove specific names (case insensitive)
    namesToRemove.forEach((name) => {
      const regex = new RegExp(name, "gi");
      cleanedText = cleanedText.replace(regex, " ");
    });

    // Remove website domains (like abc.com, www.xyz.org, etc.)
    cleanedText = cleanedText.replace(
      /\b(?:https?:\/\/)?(?:www\.)?[a-zA-Z0-9-]+\.[a-z]{2,}(?:\/[^\s]*)?/gi,
      " ",
    );

    return cleanedText;
  };

  useEffect(() => {
    async function getFunctions() {
      try {
        setGlobalLoading(true);
        const functions_list = await axios.get(
          `${API_BASE_URL}/common_controller/get_major_functions`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );
        if (functions_list.data.options.length > 0) {
          setFunctions(functions_list.data.options);
        }
      } catch (error) {
        console.log(error);
      } finally {
        setGlobalLoading(false);
      }
    }
    async function get_geography() {
      try {
        setGlobalLoading(true);
        const response = await axios.get(
          `${API_BASE_URL}/common_controller/get_countries_list`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );
        if (response.data.options.length > 0) {
          setCountry(response.data.options);
        }
      } catch (error) {
        console.log(error);
      } finally {
        setGlobalLoading(false);
      }
    }

    async function get_industry() {
      try {
        setGlobalLoading(true);
        const response = await axios.get(
          `${API_BASE_URL}/common_controller/get_master_industry_list`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );
        if (response.data.options.length > 0) {
          setIndustries(response.data.options);
        }
      } catch (error) {
        console.log(error);
      } finally {
        setGlobalLoading(false);
      }
    }

    getFunctions();
    get_geography();
    get_industry();
  }, [token]);

  const namesToRemove = [
    "Positive Moves Consulting",
    "Web:",
    "©",
    "Positive   Moves",
    "Positive  Moves",
    "Positive Moves",
    "null",
    "Disclaimer",
  ];

  useEffect(() => {
    if (mode === "role") return; // role mode never picks up a stored keyword
    const storedKeyword = localStorage.getItem("searchKeyword");

    if (!storedKeyword) {
      return;
    }

    try {
      const getKeyword = JSON.parse(storedKeyword);
      const keyword = getKeyword?.keyword?.trim();

      // Clear localStorage immediately
      localStorage.removeItem("searchKeyword");

      if (!keyword) {
        return;
      }

      // Set textarea value
      setText(keyword);

      // Force SpeechToText to remount with the new text
      setSpeechKey((prev) => prev + 1);

      // Execute AI search
      AskAi(cleanExtractedText(keyword, namesToRemove), [], false);
    } catch (error) {
      console.error("Error reading searchKeyword:", error);

      localStorage.removeItem("searchKeyword");
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (mode !== "role" || roleId || !token) return;
    (async () => {
      try {
        const res = await axios.get(
          `${API_BASE_URL}/common_controller/get_active_roles_list_with_jd`,
          { headers: { Authorization: `Bearer ${token}` } },
        );
        setRoleOptions(res.data.options || []);
      } catch (error) {
        console.log(error);
        toastr.error("Could not load roles.");
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mode, token]);

  // Existing Role: fetch the role's JD file text, then run the exact same
  // AI search as an uploaded JD.
  const handleRoleSelect = async (option) => {
    setSelectedRole(option);
    if (!option) {
      clear();
      setClarification(null);
      setText("");
      setLastQueryText("");
      return;
    }
    await runForRole(option.value);
  };

  const runForRole = async (id) => {
    clear();
    setClarification(null);
    setText("");
    setLastQueryText("");

    setIsSearching(true);
    try {
      const response = await axios.post(
        `${API_BASE_URL}/ai_candidates/get_role_jd_text`,
        { role_id: id },
        { headers: { Authorization: `Bearer ${token}` } },
      );

      if (!response.data.success) {
        toastr.error(response.data.message || "No JD found for this role.");
        setIsSearching(false);
        return;
      }

      const cleaned = cleanExtractedText(response.data.text, namesToRemove);
      setText(cleaned.trim());
      // AskAi manages isSearching from here on
      // true = replace the long JD text in the box with the AI summary
      await AskAi(cleaned, [], true);
    } catch (error) {
      console.log(error);
      toastr.error("Could not read the JD for this role.");
      setIsSearching(false);
    }
  };

  // Edit Columns -> Apply: fold the filter values into the query text as
  // explicit lines and run the normal AI search. The text box is what gets
  // searched; the AI re-extracts the filters from it.
  const applyFilters = () => {
    const labelOf = (opts, v) =>
      opts.find((o) => String(o.value) === String(v))?.label;
    const lines = [];

    if (filters.designation.trim()) {
      lines.push(`Designation: ${filters.designation.trim()}`);
    }
    const fn = labelOf(functions, filters.functionId);
    if (fn) lines.push(`Function: ${fn}`);
    const ctry = filters.countryIds
      .map((v) => labelOf(country, v))
      .filter(Boolean);
    if (ctry.length) lines.push(`Country: ${ctry.join(", ")}`);
    const ind = filters.industryIds
      .map((v) => labelOf(Industries, v))
      .filter(Boolean);
    if (ind.length) lines.push(`Industry: ${ind.join(", ")}`);

    // Drop filter lines from an earlier Apply so they don't pile up
    const base = text
      .split("\n")
      .filter((l) => !/^\s*(Designation|Function|Country|Industry)\s*:/i.test(l))
      .join("\n")
      .trim();

    if (!base && lines.length === 0) {
      toastr.error("Nothing to search on yet.");
      return;
    }

    const combined = [base, ...lines].filter(Boolean).join("\n");
    setText(combined);
    AskAi(combined, [], false);
  };

  // Role view / workstation page: the role is already known, so run the
  // search as soon as the page opens. The ref stops StrictMode's double
  // effect run from firing two (paid) AI searches.
  const autoRunRoleRef = useRef(null);
  useEffect(() => {
    if (mode !== "role" || !roleId || !token) return;
    if (autoRunRoleRef.current === String(roleId)) return;
    autoRunRoleRef.current = String(roleId);
    runForRole(roleId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mode, roleId, token]);

  const handleFileChange = (e) => {
    const file = e.target.files[0];

    if (!file) return;

    const allowedTypes = [
      "application/pdf",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx
      "application/vnd.ms-powerpoint",
      "application/vnd.openxmlformats-officedocument.presentationml.presentation", // .pptx
    ];

    if (!allowedTypes.includes(file.type)) {
      alert("Only PDF, DOC, DOCX, PPT, and PPTX files are allowed.");
      return;
    }

    const reader = new FileReader();

    reader.onload = async () => {
      if (!reader.result) return;
      if (file.type === "application/pdf") {
        const typedarray = new Uint8Array(reader.result);
        const pdf = await pdfjsLib.getDocument({ data: typedarray }).promise;

        let fullText = "";
        for (let i = 1; i <= pdf.numPages; i++) {
          const page = await pdf.getPage(i);
          const content = await page.getTextContent();
          fullText += content.items.map((item) => item.str).join(" ") + " ";
        }
        AskAi(cleanExtractedText(fullText, namesToRemove), [], true);
      } else if (
        file.type.includes("msword") ||
        file.type.includes("officedocument.wordprocessingml")
      ) {
        const result = await mammoth.extractRawText({
          arrayBuffer: reader.result,
        });
        AskAi(cleanExtractedText(result.value, namesToRemove), [], true);
      } else {
        alert("PPT parsing not yet implemented.");
      }
    };
    reader.readAsArrayBuffer(file);
  };

  const clear = () => {
    setValue("keywords", []);
    setValue("country", []);
    setValue("industry", []);
    setValue("functions", "");
    setValue("designation", "");

    setkeywords([]);
    setgptcountry([]);
    setgptindustry([]);
    setgptfunction("");
    setgptDesignation("");
    setOptions([]);
  };

  const handleKeywordsChange = (selectedOptions) => {
    const nextKeywords = (selectedOptions || []).map((opt) => {
      const existing = keywords.find((k) => k.value === opt.value);
      return (
        existing || { label: opt.label, value: opt.value, type: "must_have" }
      );
    });

    setkeywords(nextKeywords);
    setValue(
      "keywords",
      nextKeywords.map((k) => k.value),
    );
    // No auto re-search here — edits just update local state; the
    // updated keyword list gets sent on the next explicit
    // "Search Candidates" click via onSubmit's must-have-skills logic.
  };

  async function AskAi(
    value,
    mustHaveSkillsOverride,
    showSummaryInTextarea,
    clarificationPayload,
    isKeywordEdit,
  ) {
    const text = value.trim();

    if (text.length <= 0) {
      toastr.error("Please enter a valid text");
      return;
    }

    setIsSearching(true);

    try {
      const response = await axios.post(
        `${API_BASE_URL}/aiAssistant/askAI`,
        {
          query: text,
          must_have_skills: mustHaveSkillsOverride || [],
          clarification: clarificationPayload || undefined,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const data = response.data;

      if (!data.success) {
        toastr.error(data.error || "Search failed, please try again.");
        setOptions([]);
        setArr(true);
        return;
      }

      if (data.needs_clarification) {
        // Role mode: show the short summary instead of the full JD text
        if (mode === "role" && data.summary) setText(data.summary);
        setClarification({
          query: text,
          ambiguityScore: data.ambiguity_score,
          options: data.interpretation_options,
        });
        setOptions([]);
        return;
      }

      setClarification(null);

      setLastQueryText(text);

      if ((showSummaryInTextarea || clarificationPayload) && data.summary) {
        setText(data.summary);
        // Role mode: the visible summary is now the query of record, so a
        // keyword-only re-search doesn't look like "new text" and re-extract.
        if (mode === "role") setLastQueryText(data.summary.trim());
      }

      // Role view: leave out candidates already mapped to this role
      let resultRows = data.result || [];
      if (mode === "role" && roleId) {
        try {
          const mappedRes = await axios.get(
            `${API_BASE_URL}/roles/mapped_candidates/${roleId}`,
            { headers: { Authorization: `Bearer ${token}` } },
          );
          const mappedIds = new Set(
            (mappedRes.data || []).map((c) => String(c.id)),
          );
          resultRows = resultRows.filter((r) => !mappedIds.has(String(r.id)));
        } catch (err) {
          console.log("Could not load mapped candidates", err);
        }
      }

      // Table data
      setOptions(resultRows);
      setArr(resultRows.length === 0);

      /* Announce the outcome for the Ask Pine widget, which cannot otherwise
         see it — it hands the brief over and the turn ends at navigation.
         A plain DOM event keeps the two sides uncoupled: this page imports
         nothing from the widget, and if the widget is not mounted the event
         is simply unheard. */
      try {
        window.dispatchEvent(
          new CustomEvent("askpine:search-result", {
            detail: { query: text, count: (data.result || []).length },
          }),
        );
      } catch (error) {
        console.error("Ask Pine result signal failed:", error);
      }

      setCandidateIds(resultRows.map((r) => r.id));

      // Extracted keywords (must_have + related), tagged by type
      // Extracted keywords (must_have + related), tagged by type —
      // only overwrite this from a fresh GPT extraction when the search
      // wasn't triggered by the user editing keywords themselves. A
      // keyword-edit-triggered re-search should keep the user's own
      // edited list as-is; re-extracting and overwriting it here is
      // exactly what caused keywords to churn/duplicate on every edit.
      if (!isKeywordEdit) {
        const extractedKeywords = data.extracted?.keywords || [];
        setkeywords(extractedKeywords);
        setValue(
          "keywords",
          extractedKeywords.map((k) => k.value),
        );
      }

      // Filter box auto-fill — SAME shape submit() always returned,
      // so NewSearchCandidates.jsx / SearchRole don't need any changes
      submit?.({
        country: data.extracted?.countries || [],
        industry: data.extracted?.industries || [],
        function: data.extracted?.functions?.[0] || null,
        designation: data.extracted?.designation || null,
        related_countries: [],
        related_designations: data.extracted?.related_designations || [],
      });

      // AI Candidates page: show what the AI extracted in the filter form
      if (mode === "role" && roleId) {
        const ex = data.extracted || {};
        setFilters({
          designation: ex.designation || "",
          functionId: ex.functions?.[0] != null ? String(ex.functions[0]) : "",
          countryIds: (ex.countries || []).map(String),
          industryIds: (ex.industries || []).map(String),
        });
      }

      // "My roles" dropdown, for mapping/excluding candidates on a workstation
      try {
        const my_roles = await axios.get(
          `${API_BASE_URL}/common_controller/get_my_roles`,
          { headers: { Authorization: `Bearer ${token}` } },
        );
        setmyroles(
          my_roles.data.options?.length > 0 ? my_roles.data.options : [],
        );
      } catch (err) {
        console.log(err);
      }
    } catch (error) {
      console.log(error);
      toastr.error("Search failed, please try again.");
    } finally {
      setIsSearching(false);
    }
  }

  /* ---------------- Ask Pine agent hand-off ----------------
     The Ask Pine widget routes here with a prepared candidate brief in router
     state. Do exactly what a user would: put the brief in the box, then press
     Search Candidates.

       setText    -> flows into <SpeechToText> via its jdtext prop, which is
                     what actually fills the textarea
       AskAi(...) -> the same call the Search Candidates button makes

     Two things make the fill delicate, hence the setTimeout:

     1. <SpeechToText> keeps its own copy of the text and pushes it up through
        onTextChange while it is still mounting — i.e. it emits "" back into
        this component's state.
     2. StrictMode runs that mount pass twice, but the ref guard below means
        our effect only writes once. So a synchronous setText(brief) is made,
        then overwritten by the second pass's "" and never re-applied.

     Deferring by a macrotask lands the write after both passes have settled.
     For the same reason, do NOT bump speechKey here: remounting SpeechToText
     just replays the empty emit.

     Router state is cleared afterwards so a refresh or Back does not re-search.
     No-op when there is no agent state. */
  const location = useLocation();
  const navigate = useNavigate();
  const agentRunRef = useRef(null);

  useEffect(() => {
    if (mode === "role") return; // Ask Pine hand-off belongs to the JD tab
    try {
      const brief = location.state?.agentQuery;
      const stamp = location.state?.agentAt;
      if (!brief || agentRunRef.current === stamp) return;
      agentRunRef.current = stamp;

      setTimeout(() => setText(brief), 0);
      AskAi(cleanExtractedText(brief, namesToRemove), [], false);

      navigate(location.pathname, { replace: true, state: null });
    } catch (error) {
      console.error("Ask Pine hand-off failed:", error);
      toastr.error("Could not start that search — try the button below.");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.state]);

  useEffect(() => {
    const $selectMyroles = $("select[name='myroles']");
    $selectMyroles.select2({
      placeholder: "Select the role you are working on",
    });

    $selectMyroles.on("change", function (e) {
      const selectedValues = $(this).val();
      if (selectedValues.length > 0) {
        $("#discard_candidates").removeClass("hide");
        setselectedmyroles(selectedValues);
      } else {
        $("#discard_candidates").addClass("hide");
        setselectedmyroles([]);
      }
      setValue("myroles", selectedValues || []); // update react-hook-form
    });

    return () => {
      $selectMyroles.select2("destroy");
    };
  }, [myroles]);

  const onSubmitmyroles = async (data) => {
    // console.log(data);
    // console.log(selectedmyroles);
    // console.log(CandidateIds);
    // return;
    try {
      setIsSearching(true);
      const response = await axios.get(
        `${API_BASE_URL}/roles/mapped_candidates/${selectedmyroles}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      if (response.data.length > 0) {
        console.log("selected role candidates", response.data);

        const mappedCandidates = response.data.map((c) => c.id);

        const unmappedCandidates = CandidateIds.filter(
          (c) => !mappedCandidates.includes(c),
        );

        setOptions(options.filter((c) => unmappedCandidates.includes(c.id)));
      }
    } catch (error) {
      setIsSearching(false);
      console.log(error);
    } finally {
      setIsSearching(false);
    }
  };

  useEffect(() => {
    const ids = Object.keys(rowSelection);

    console.log("ids", ids);

    if (ids.length > 0) {
      $("#map_candidates").removeClass("hide");
      setSelectedIds(ids);
    } else {
      $("#map_candidates").addClass("hide");
      setSelectedIds([]);
    }
  }, [rowSelection, options]);

  const mapCandidates = async () => {
    // Role view: the role is known, no dropdown needed
    const targetRole = roleId ? String(roleId) : selectedmyroles;
    if (!targetRole || targetRole.length === 0) {
      // Show error, focus the select2, and stop
      const $selectMyroles = $("select[name='myroles']");

      alert("Please select the role you are working on");
      // Focus on the select2 dropdown
      $selectMyroles.select2("open");

      return; // Prevent further processing
    }

    const data = {
      selectedId: selectedIds,
      selectedRole: targetRole,
    };
    try {
      setIsSearching(true);
      const response = await axios.post(
        `${API_BASE_URL}/ai_candidates/map_to_role`,
        {
          data,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      if (response.data.success == true) {
        setOptions((prevOptions) =>
          prevOptions.filter((item) => !selectedIds.includes(String(item.id))),
        );

        setRowSelection({});
        setSelectedIds([]);
        toastr.success(response.data.message);
      } else {
        toastr.error(response.data.message);
      }
    } catch (error) {
      setIsSearching(false);
      console.log(error);
    } finally {
      setIsSearching(false);
    }

    // Proceed with mapping logic here
  };

  function handleClarificationChoice(option) {
    if (option.id === "custom") {
      return; // wait for the text input + button below instead
    }

    AskAi(clarification.query, [], false, { selected_option: option.label });
  }

  function submitCustomClarification() {
    if (!customClarificationText.trim()) return;

    AskAi(clarification.query, [], false, {
      selected_option: "custom",
      custom_text: customClarificationText,
    });

    setCustomClarificationText("");
  }

  return (
    <>
      <div className="content">
        {/* <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
          <div className="my-auto mb-2">
            <h2 className="mb-1">Describe the Role</h2>
            <p className="fs-12">
              <div className="text-warning fw-semibold mb-2">
                ✨ AI-powered semantic matching
              </div>
            </p>
          </div>
        </div> */}

        <div className="card">
          <div className="card-body">
            <div>
              <div className="row">
                <div className="col-md-12">
                  {mode === "role" && roleId && (
                    <div className="mb-3">
                      <button
                        type="button"
                        className="btn btn-outline-primary btn-sm"
                        disabled={isSearching}
                        onClick={() => setShowFilterForm((p) => !p)}
                      >
                        {showFilterForm ? "Hide Form" : "Edit Columns"}
                      </button>

                      {showFilterForm && (
                        <div className="border rounded p-3 mt-2 bg-light">
                          <div className="row g-3">
                            <div className="col-md-6">
                              <label className="form-label small text-uppercase">
                                Designation
                              </label>
                              <input
                                className="form-control"
                                type="text"
                                placeholder="Designation"
                                value={filters.designation}
                                onChange={(e) =>
                                  setFilters((p) => ({
                                    ...p,
                                    designation: e.target.value,
                                  }))
                                }
                              />
                            </div>
                            <div className="col-md-6">
                              <label className="form-label small text-uppercase">
                                Function
                              </label>
                              <select
                                className="form-select"
                                value={filters.functionId}
                                onChange={(e) =>
                                  setFilters((p) => ({
                                    ...p,
                                    functionId: e.target.value,
                                  }))
                                }
                              >
                                <option value="">Select Function</option>
                                {functions.map((f) => (
                                  <option key={f.value} value={String(f.value)}>
                                    {f.label}
                                  </option>
                                ))}
                              </select>
                            </div>
                            <div className="col-md-6">
                              <label className="form-label small text-uppercase">
                                Country
                              </label>
                              <Select
                                isMulti
                                closeMenuOnSelect={false}
                                hideSelectedOptions={true}
                                options={country}
                                placeholder="Select Country"
                                value={country.filter((o) =>
                                  filters.countryIds.includes(String(o.value)),
                                )}
                                onChange={(sel) =>
                                  setFilters((p) => ({
                                    ...p,
                                    countryIds: (sel || []).map((o) =>
                                      String(o.value),
                                    ),
                                  }))
                                }
                              />
                            </div>
                            <div className="col-md-6">
                              <label className="form-label small text-uppercase">
                                Industry
                              </label>
                              <Select
                                isMulti
                                closeMenuOnSelect={false}
                                hideSelectedOptions={true}
                                options={Industries}
                                placeholder="Select Industry"
                                value={Industries.filter((o) =>
                                  filters.industryIds.includes(String(o.value)),
                                )}
                                onChange={(sel) =>
                                  setFilters((p) => ({
                                    ...p,
                                    industryIds: (sel || []).map((o) =>
                                      String(o.value),
                                    ),
                                  }))
                                }
                              />
                            </div>
                          </div>
                          <div className="text-end mt-3">
                            <button
                              type="button"
                              className="btn btn-primary btn-sm"
                              disabled={isSearching}
                              onClick={applyFilters}
                            >
                              Apply &amp; Search
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                  {!clarification && mode === "role" && !roleId && (
                    <div className="mb-3">
                      <label className="form-label">
                        Select an existing role — its JD will be used to find
                        candidates.
                      </label>
                      <Select
                        isClearable
                        isDisabled={isSearching}
                        options={roleOptions}
                        value={selectedRole}
                        onChange={handleRoleSelect}
                        placeholder="Select Active Role"
                      />
                    </div>
                  )}
                  {mode === "role" && (selectedRole || roleId) && (
                    <div className="mb-3">
                      <label className="form-label">
                        Description sent for search
                        <i
                          className="fa fa-info-circle ms-1"
                          title="This is the JD text used for the search. Edit it and click Search Candidates to search again."
                        ></i>
                      </label>
                      <textarea
                        className="form-control"
                        rows={8}
                        value={text}
                        disabled={isSearching}
                        onChange={(e) => {
                          setText(e.target.value);
                          // Edited text invalidates any pending clarification
                          // options — the next Search runs on the new text.
                          if (clarification) setClarification(null);
                        }}
                        placeholder="JD text will appear here once a role is selected"
                      />
                      <small className="text-muted">
                        You can edit this description and click “Search
                        Candidates” to search again.
                      </small>
                    </div>
                  )}
                  {!clarification && mode !== "role" && (
                    <div className="mb-3">
                      <label className="form-label">
                        Type a role brief, record a voice note, or upload a JD
                        to start your search.
                        <i
                          className="fa fa-info-circle"
                          title="Atleast 10 words"
                        ></i>
                      </label>
                      <SpeechToText
                        key={speechKey}
                        extractedText={(text) => {
                          if (text.trim() === "") {
                            return;
                          }

                          AskAi(
                            cleanExtractedText(text, namesToRemove),
                            [],
                            false,
                          );
                        }}
                        textchange={(text) => {
                          if (text.trim() === "") {
                            return;
                          }

                          clear();
                        }}
                        jdtext={text || ""}
                        onTextChange={setText}
                      />
                      <div className="mt-2" style={{ placeItems: "center" }}>
                        <span
                          style={{
                            cursor: "none",
                            width: "10px",
                            height: "28px",
                            fontSize: "10px",
                          }}
                          class="btn btn-icon btn-secondary rounded-pill border border-rounded d-flex justify-content-center mb-2"
                        >
                          OR
                        </span>
                        <input
                          id="jd-upload"
                          type="file"
                          className="d-none"
                          accept=".pdf,.doc,.docx"
                          {...register("file", {
                            required:
                              keywords.length > 0 ? false : "File is missing",
                            onChange: handleFileChange,
                          })}
                          disabled={
                            isSearching ||
                            (keywords.length === 0 &&
                              text.trim().split(/\s+/).filter(Boolean).length >
                                0)
                          }
                        />

                        <label
                          htmlFor="jd-upload"
                          className={`btn ${isSearching || (keywords.length === 0 && text.trim().split(/\s+/).filter(Boolean).length > 0 ? "btn-outline-dark" : "btn-outline-primary")} px-4 py-3`}
                          style={{ cursor: "pointer", width: "100%" }}
                          disabled={
                            isSearching ||
                            (keywords.length === 0 &&
                              text.trim().split(/\s+/).filter(Boolean).length >
                                0)
                          }
                        >
                          <i className="fa-solid fa-upload me-2"></i>
                          Upload a JD (PDF, DOC, DOCX)
                        </label>

                        {errors.file && (
                          <div className="text-danger mt-2">
                            {errors.file.message}
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              </div>
              {keywords.length > 0 && (
                <div className="row">
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="form-label">Extracted Keywords</label>
                      <CreatableSelect
                        isMulti
                        isClearable={false}
                        value={keywords.map((k) => ({
                          label: k.label,
                          value: k.value,
                        }))}
                        onChange={handleKeywordsChange}
                        placeholder="Upload or type JD to extract skills or add new skills"
                        formatCreateLabel={(input) => `Add "${input}"`}
                      />
                    </div>
                  </div>
                </div>
              )}
              {clarification && (
                <div className="row">
                  <div className="col-md-12">
                    <div className="mb-3 p-3 border rounded bg-light">
                      <label className="form-label fw-semibold">
                        How should we interpret this search?
                      </label>
                      <div className="d-flex flex-column gap-2">
                        {clarification.options
                          .filter((option) => option.id !== "custom")
                          .map((option) => (
                            <button
                              key={option.id}
                              type="button"
                              className="btn btn-outline-primary text-start"
                              onClick={() => handleClarificationChoice(option)}
                            >
                              {option.label}
                            </button>
                          ))}
                      </div>

                      <div className="mt-3">
                        <label className="form-label small text-uppercase">
                          Describe your requirement, if none of the above option
                          is sufficient.
                        </label>
                        <div className="d-flex gap-2">
                          <input
                            className="form-control"
                            type="text"
                            placeholder="Type your own interpretation..."
                            value={customClarificationText}
                            onChange={(e) =>
                              setCustomClarificationText(e.target.value)
                            }
                          />
                          <button
                            type="button"
                            className="btn btn-primary"
                            onClick={submitCustomClarification}
                            disabled={!customClarificationText.trim()}
                          >
                            Search
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              <div className="text-end">
                <button
                  disabled={
                    isSearching ||
                    (keywords.length === 0 &&
                      text.trim().split(/\s+/).filter(Boolean).length < 1)
                  }
                  type="button"
                  className="btn btn-primary"
                  onClick={() => {
                    const currentText = text.trim();
                    const isNewQuery = currentText !== lastQueryText.trim();

                    if (isNewQuery || keywords.length === 0) {
                      // Either no search has run yet, or the textarea
                      // content has changed since the last search — treat
                      // this as a fresh search on the CURRENT text, not
                      // a re-run of whatever was last searched.
                      AskAi(
                        cleanExtractedText(currentText, namesToRemove),
                        [],
                        false,
                      );
                    } else {
                      // Same query as last time, only keyword edits
                      // changed — re-run with the updated must-have list.
                      handleSubmit(onSubmit)();
                    }
                  }}
                >
                  {isSearching ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      Searching...
                    </>
                  ) : (
                    "Search Candidates"
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
        {roleId ? (
          selectedIds.length > 0 && (
            <div className="card">
              <div className="card-body">
                <button
                  type="button"
                  className="btn btn-success fs-10"
                  onClick={mapCandidates}
                >
                  <i className="ti ti-checks"></i> Add candidates to workstation
                </button>
              </div>
            </div>
          )
        ) : myroles && myroles.length > 0 ? (
          <form onSubmit={handleSubmit(onSubmitmyroles)}>
            <div className="card">
              <div className="card-body">
                <div className="row">
                  <div className="col-md-4">
                    <select
                      {...register("myroles")}
                      className="form-select select2"
                      style={{ width: "44.917px" }}
                    >
                      <option value={""}>
                        Select the role you are working on
                      </option>
                      {myroles.map((item, index) => (
                        <option key={index} value={item.value}>
                          {item.label}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-8">
                    <button
                      className="btn btn-info hide fs-10"
                      id="discard_candidates"
                      type="submit"
                    >
                      <i className="fe fe-eye-off"></i> Exclude candidates of
                      workstation
                    </button>
                    <a
                      href="javascript:void(0)"
                      className="btn btn-success hide fs-10"
                      id="map_candidates"
                      style={{ marginLeft: "10px" }}
                      onClick={handleSubmit(mapCandidates)}
                    >
                      <i className="ti ti-checks"></i> Add candidates to
                      workstation
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </form>
        ) : (
          ""
        )}
        <div className="card" ref={resultsRef}>
          <div className="card-body">
            <h5 className="mb-3">Search result</h5>
            <div className="row">
              <div className="col-md-12 text-center">
                {isSearching ? (
                  <div className="py-5">
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                    <p className="mt-3 text-muted">
                      Searching for candidates...
                    </p>
                  </div>
                ) : options.length > 0 ? (
                  <MaterialReactTable
                    key={options.length}
                    columns={columns}
                    data={options}
                    getRowId={(row) => row.id}
                    enableRowSelection
                    enablePagination
                    enableSorting
                    enableColumnFilters
                    onRowSelectionChange={setRowSelection}
                    enableRowVirtualization={false}
                    state={{ rowSelection }}
                    initialState={{
                      pagination: { pageIndex: 0, pageSize: 50 },
                      showColumnFilters: true,
                    }}
                  />
                ) : (
                  <>
                    <img
                      width={"16%"}
                      src="..\assets\img\icons\people_search_icon.png"
                    />
                    <p>
                      <b>
                        {arr === true
                          ? "No Candidate found."
                          : "No candidates yet! Start uploading JD for personalised results."}
                      </b>
                    </p>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default UploadJd;
